/* eslint-disable radix */
import { merge } from 'ramda';
import Utils from 'src/utils';
import { SUCCESS, FAIL, REQUEST, OPTIONS_SUCCESS, GET_SIMPLE_REGISTRATORS_SUCCESS, PUT_SIMPLE_REGISTRATORS_SUCCESS } from 'src/store/actions/deviceActions';
const initialState = {
    list: [],
    options: [],
    fetching: false,
    errors: [],
    simpleRegistrators: []
};
const devicesReducer = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST:
            return merge(state, { fetching: true });
        case SUCCESS:
            return merge(state, { list: action.jobs, fetching: false });
        case OPTIONS_SUCCESS:
            return merge(state, { options: action.jobs });
        case FAIL:
            return merge(state, { errors: action.error, fetching: false });
        case GET_SIMPLE_REGISTRATORS_SUCCESS:
            return merge(state, { simpleRegistrators: action.simpleRegistrators });
        case PUT_SIMPLE_REGISTRATORS_SUCCESS:
            return merge(state, {
                simpleRegistrators: Utils.arrays.mergeWithNestedObjectsReplace(state.simpleRegistrators, [action.simpleRegistrator], 'Id')
            });
        default:
            return state;
    }
};
export default devicesReducer;
